module.exports = __webpack_public_path__ + "img/1alB-ts-tsupe.94f15ed8.jpg";